import { createContextReducer } from "../../common/helpers/createContextReducer";
import { initialState } from "./constants";
import { APP_MODE, IAppConfig, IConfigState, ILocation, IStallMode } from "./types";

const ConfigReducer = {
	SET_CATALOGUE_DATA: (state: IConfigState, data: ILocation) => {
		state.location = data;
	},
	SET_STALL_MODE: (state: IConfigState, appMode: IStallMode) => {
		state.stallMode = appMode;
	},
	SET_APP_MODE: (state: IConfigState, appMode: APP_MODE) => {
		state.appMode = appMode;
	},
	SET_SESSION: (state: IConfigState, { session_id }: { session_id: string }) => {
		state.user.session_id = session_id;
	},
	INIT_CONFIG: (state: IConfigState, data: IAppConfig) => {
		state.config = data;
		state.config.bcrs_deposit_rate = data.bcrs_deposit_rate ?? 10;
		state.config.enableDevTools = data.enableDevTools ?? true;
		state.inited = true;
		// Only reassign stallMode when the resolved value actually changes. A redundant
		// assignment forces ConditionTheme's useEffect to re-run and re-inject the
		// favicon + theme body class, which presents as a visible flicker on refresh.
		if (state.stallMode !== data.stall.mode) {
			state.stallMode = data.stall.mode;
		}
		// Preserve the existing location reference when the underlying name is unchanged.
		// INIT_CONFIG only carries the stall name (id is owned by INIT_LOCATION_ID), so
		// rebuilding a fresh object literal every dispatch invalidates downstream selectors
		// that depend on location identity even when its value is stable.
		if (state.location.name !== data.stall.name) {
			state.location.name = data.stall.name;
		}
	},
	INIT_LOCATION_ID: (state: IConfigState, { location_id }: { location_id: string }) => {
		state.location = { id: location_id, name: "", outletid: "", description: "" };
	},
	TOGGLE_DEV_MODE: (state: IConfigState) => {
		state.devMode = !state.devMode;
	},
	GRANT_ADMIN_ACCESS: (state: IConfigState) => {
		state.adminAccessGranted = true;
	},
	REVOKE_ADMIN_ACCESS: (state: IConfigState) => {
		state.adminAccessGranted = false;
	},
	GRANT_MAINTENANCE_ACCESS: (state: IConfigState) => {
		state.maintenanceAccessGranted = true;
	},
	REVOKE_MAINTENANCE_ACCESS: (state: IConfigState) => {
		state.maintenanceAccessGranted = false;
	},
};

const {
	AppProvider: ConfigProvider,
	useContextActions: useConfigActions,
	useContextPartial: useConfigContext,
} = createContextReducer(initialState, ConfigReducer);

export { ConfigProvider, useConfigActions, useConfigContext };
